module.exports = __webpack_public_path__ + "img/filter-switch-asc.9831ff6b.svg";